import moment from 'moment'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import { useSelector } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const Completed = ({ modules, loading }) => {
    const navigate = useNavigate();
    const userData = useSelector((state) => state.userSlice);

    const handleMyLearning = (e) => {
        navigate(`/course/details/${e.uuid}`, {
          state: {
            name: e.name || "",
            userUUID: userData?.user?.uuid || "",
            previousLocationPathname: null,
          },
        });
      };



    return (
        <>
        {modules.map &&
            <>
            <h5> {loading ?  <Skeleton width="5vw" />  : <> Completed </> } </h5>
            <div className='completeddf ucomple'>
            {loading ? 
            <>
            <div className="completedlist cursorPointer">
                        <div className='cmpbox'>                       
                            <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                            <p><Skeleton width="5vw" highlightColor="#ffffff"/></p>
                        </div>
                        <div className='perbox'>
                            <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                        </div>
                    </div>
            <div className="completedlist cursorPointer">
                        <div className='cmpbox'>                       
                            <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                            <p><Skeleton width="5vw" highlightColor="#ffffff"/></p>
                        </div>
                        <div className='perbox'>
                            <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                        </div>
                    </div>
            <div className="completedlist cursorPointer">
                        <div className='cmpbox'>                       
                            <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                            <p><Skeleton width="5vw" highlightColor="#ffffff"/></p>
                        </div>
                        <div className='perbox'>
                            <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                        </div>
                    </div>
            </> :
            <>
                {modules.map((item, index) => {
                    return <div key={index} onClick={() => handleMyLearning(item)} className="completedlist cursorPointer">
                        <div className='cmpbox'>
                            <Tooltip title={item.name}> 
                            <h6>{item.name}</h6>
                            </Tooltip>
                            {item.certificate && <p>{moment(item.certificate.createdAt).fromNow()}</p>}
                        </div>
                        <div className='perbox'>
                            <span>{item.progress}%</span>
                        </div>
                    </div>
                })}
                </> }
            </div>
            </>
            }
        </>
    )
}

export default Completed
